"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWindowsOS = exports.isDesktopUA = exports.isSnapchat = exports.isTiktok = exports.extractBrowser = exports.extractDeviceData = exports.extractBrowserName = exports.extractUA = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const POSSIBLE_DESKTOP_OS_STRINGS = ["windows", "mac", "linux"];
const SNAPCHAT_IN_APP_BROWSER = "Snapchat";
const TIKTOK_IN_APP_BROWSER = "TikTok";
function extractUA() {
    const parser = new ua_parser_js_1.UAParser();
    const browser = parser.getBrowser();
    const device = extractDeviceData(parser);
    const os = parser.getOS().name;
    const osVersion = parser.getOS().version;
    const lowerCasedUAString = parser.getUA().toLowerCase();
    const browserName = extractBrowserName(lowerCasedUAString, browser.name);
    return {
        browserName,
        browserVersion: browser.version,
        os,
        osVersion,
        deviceManufacturer: device.vendor,
        deviceName: device.model,
        deviceType: device.type,
    };
}
exports.extractUA = extractUA;
function extractBrowserName(lowerCasedUAString, defaultBrowserName) {
    // Check for TikTok web-view
    if (lowerCasedUAString.includes("bytedance") ||
        lowerCasedUAString.includes("tiktok") ||
        lowerCasedUAString.includes("musical_ly")) {
        return TIKTOK_IN_APP_BROWSER;
    }
    // Check for Snapchat web-view
    if (lowerCasedUAString.includes("snapchat")) {
        return SNAPCHAT_IN_APP_BROWSER;
    }
    return defaultBrowserName;
}
exports.extractBrowserName = extractBrowserName;
function extractDeviceData(uaParser) {
    const parser = uaParser ?? new ua_parser_js_1.UAParser();
    const deviceData = parser.getDevice();
    const osString = parser.getOS().name;
    if (!deviceData.type &&
        osString &&
        POSSIBLE_DESKTOP_OS_STRINGS.filter((desktopOs) => osString.toLowerCase().includes(desktopOs))
            .length) {
        deviceData.type = "desktop";
        deviceData.model = osString;
    }
    if (deviceData.type === "mobile" &&
        !deviceData.model &&
        osString &&
        osString.toLowerCase().includes("android")) {
        deviceData.model = "Android";
    }
    return deviceData;
}
exports.extractDeviceData = extractDeviceData;
function extractBrowser() {
    const canonicalUrl = window.location.href;
    const referrer = document.referrer;
    const deviceScreenWidth = window.screen.width.toString();
    const deviceScreenHeight = window.screen.height.toString();
    return {
        canonicalUrl,
        referrer,
        deviceScreenWidth,
        deviceScreenHeight,
    };
}
exports.extractBrowser = extractBrowser;
function isTiktok() {
    const parser = new ua_parser_js_1.UAParser();
    const browser = parser.getBrowser();
    const lowerCasedUAString = parser.getUA().toLowerCase();
    const browserName = extractBrowserName(lowerCasedUAString, browser.name);
    return browserName === TIKTOK_IN_APP_BROWSER;
}
exports.isTiktok = isTiktok;
function isSnapchat() {
    const parser = new ua_parser_js_1.UAParser();
    const browser = parser.getBrowser();
    const lowerCasedUAString = parser.getUA().toLowerCase();
    const browserName = extractBrowserName(lowerCasedUAString, browser.name);
    return browserName === SNAPCHAT_IN_APP_BROWSER;
}
exports.isSnapchat = isSnapchat;
function isDesktopUA(uaParser) {
    const deviceData = extractDeviceData(uaParser);
    return deviceData.type === "desktop";
}
exports.isDesktopUA = isDesktopUA;
function isWindowsOS() {
    const parser = new ua_parser_js_1.UAParser();
    const stringOS = parser.getOS().name?.toLowerCase();
    return Boolean(stringOS?.includes("windows"));
}
exports.isWindowsOS = isWindowsOS;
//# sourceMappingURL=extraction.js.map